import React from "react";
import { useTranslation } from "react-i18next";
import { BasketPageCheckoutOrderModel, EshopDiscount } from "./checkoutOrderView";
import { useRemoveDiscountCodeMutation } from "./basketHooks";
import currencyFormatter, { Currency } from "@/common/CurrencyFormatter";

interface BasketUsedDiscountCodeProperties {
    readonly itemsAmount: number;
    readonly itemsAmountWithoutDiscount: number;
    readonly isApplied: boolean;
    readonly eshopDiscount: EshopDiscount;
    readonly onModelChange: (model: BasketPageCheckoutOrderModel) => void;
    readonly currency: Currency;
}

export default function BasketUsedDiscountCode({
    itemsAmount,
    itemsAmountWithoutDiscount,
    eshopDiscount,
    onModelChange,
    isApplied,
    currency,
}: BasketUsedDiscountCodeProperties): React.JSX.Element {
    const { t } = useTranslation("basket");
    const clearDiscountCodeMutation = useRemoveDiscountCodeMutation(onModelChange);

    const handleClearDiscountCode = (event: React.MouseEvent): void => {
        event.preventDefault();
        clearDiscountCodeMutation.mutate();
    };

    return (
        <div className="cart-item-wrap discount-code">
            <div className="cart-item-inner">
                <div className="cart-item-product-image">
                    <span className="cart-item-product-image-helper"></span>
                    <img src="/css/image/discount-coupon.png" alt="" />
                </div>
                <div className="cart-item-product-title-availability-labels">
                    <span className="cart-discount-title">{eshopDiscount.title}</span>
                    <div className="cart-item-discount-code">{t("enteredCode")}<span><i
                        className="fa-solid fa-check-circle">
                    </i>{eshopDiscount.code}
                    </span>
                    </div>
                    {isApplied
                        ? <div className="cart-item-discount-value">{t("discountWithCode")} <span>{currencyFormatter.formatCurrencyWithSymbol(itemsAmountWithoutDiscount - itemsAmount, currency)}</span></div>
                        : <div className="cart-item-discount-not-applied">{t("codeEnteredButNotApplied")}</div>}
                    {eshopDiscount.validTo !== null && <div className="cart-item-discount-code">{t("validUntil", { date: eshopDiscount.validTo })}</div>}
                </div>
                <div className="cart-item-product-remove"><a href="#" onClick={handleClearDiscountCode}><i
                    className="fa-solid fa-trash-can">
                </i>
                </a>
                </div>
            </div>
        </div>
    );
}
